import { Button, Container, FormControlLabel, Grid, InputAdornment, TextField } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check';
import Alert from '@mui/material/Alert';
import axios from 'axios'
import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import { authContext } from '../../context/AuthContext';
import PageHeader from '../helper/PageHeader'
import { withTranslation } from 'react-i18next';
import { zoomTraining, zoomOnlyCourseId  } from '../../constants/global'
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';


// Page for zoom trainnig user to enter the Zoom training code and their answers on CEU and certifcation test.
// the code is verified, if good, creaet a uesr training record with  this special "zoom training only " course 
// if code bad brings up back button
const ZoomClass = props => {
    const {t} = props;
    const [code, setCode] = useState({ value: '', valid: false })
    const [foundCode, setFoundCode] = useState({ code: null, valid: false, searched: false })
    const [ceu, setCeu] = useState({needCEU:false, message: <>{ t('EnterCode.noCEU') }<br />{t('EnterCode.noCEUIF')} </>  } ) // the chedk box for needCEU
    const [test, setTest] = useState({needTest:false, message:<>{t('EnterCode.noTest')} <br /> {t('EnterCode.noTestIF')} <br /> {t('EnterCode.noTestTC')} <br /> {t('EnterCode.noTestTrainingTab')} <br /> {t('EnterCode.noTestClassCompletion')} </>}) // the chedk box for needTest


    const userMain = useContext(authContext)
    const user = userMain.user
    const history = useHistory()

    const handleCode = (event) => {
        if (event.target.value.length > 10) 
            return // prevent longer than 10 entries
        //minimum is 6 characters, max is 10
        setCode({ value: event.target.value, valid: event.target.value.length >= 6 }) 
    }

    const onVerify = async () => {
        let res
        try {
            res = await axios.get('/api/userTraining/validate/' + code.value, {
                params: {
                    trainingType: zoomTraining
                }
            })
        } catch (e) {
            setFoundCode({ code: null, valid: false, validsearched: false })
            return
        }
        console.log(res)

        let temp = res.data.trainingCode

        // temp = temp[0]
        setFoundCode({ code: temp, valid: temp.status === 1, searched: true })
    }

    const handleRemoteChange = event => {
        if (event.target.value === 'Yes') {
            
            setCeu({
                needCEU: true,
                message: <> {t('EnterCode.needCEU')} <br />  {t('EnterCode.needCEUAccount')} <br /> {t('EnterCode.needCEUTrainingDay')} </>
            });
            
        } else {
            setCeu({
                needCEU: false,
                message :
                    <>
                       { t('EnterCode.noCEU') }
                       <br />
                        {t('EnterCode.noCEUIF')} 
                    </>

                
            });
        }
    }

    const handleNeedTest = event => {
        if (event.target.value === 'Yes') {
            
            setTest({
                needTest: true,
                message: <> {t('EnterCode.needTest')} <br /> {t('EnterCode.needTestCost')} <br /> {t('EnterCode.needTestInst')} <br /> {t('EnterCode.needTestClass')} <br /> {t('EnterCode.needTestOnline')} <br /> {t('EnterCode.needTestOptional')} </>
            });
            
        } else {
            setTest({
                needTest: false,
                message : <>{t('EnterCode.noTest')} <br /> {t('EnterCode.noTestIF')} <br /> {t('EnterCode.noTestTC')} <br /> {t('EnterCode.noTestTrainingTab')} <br /> {t('EnterCode.noTestClassCompletion')} </>
            });
        }
    }

    const onSubmit = async () => {
        let data = {
            username: user.username,
            courseId: zoomOnlyCourseId,
            trainingCode: code.value,
            needCEU: ceu.needCEU,
            needTest: test.needTest,
            disabled: true
        }

         let res = await axios('/api/userTraining/remote', {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': userMain.accessToken
              }
          });

        console.log(res)
        userMain.updateIsTrainee(true);
        if (res.data.goConfirm) {
            history.push({
                pathname : '/dashboard/user/'+user.username,
                state :{
                    afterRedeem : true
                }
            });
        } else {
            history.push('/dashboard');
        }
      
    }

    return (
        <>
            <PageHeader
                title={t('EnterCode.ZoomTraining') + ' for ' + user.name}
                cancel={history.goBack} 
            />
                <>
                    <Grid container spacing={3}>
                        <Container maxWidth="md">

                        {t('EnterCode.ZoomText')}

                        <Grid 
                        container
                        direction="row"
                        >
                            <Grid item xs={9}>
                                <TextField
                                        label={ t('EnterCode.ZoomCode') }
                                        value={code.value}
                                        onChange={handleCode}
                                        error={!code.valid}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {foundCode.valid ? <CheckIcon /> : ""}
                                                </InputAdornment>
                                            )
                                        }}
                                        fullWidth
                                        m={5}
                                    />
                            </Grid>
                            

                                <Grid item xs={3} style={{ textAlign: "center", marginTop:30 }} >
                                        <Button
                                            disabled={!code.valid}
                                            variant="outlined"
                                            color="primary"
                                            type="submit"
                                            onClick={onVerify}
                                        >
                                            {t('EnterCode.VerifyCode')}
                                        </Button>
                                </Grid>
                        </Grid>
                            

                            <Grid item xs={12} sm={6}>
                                <br />
                                <FormLabel component="legend"> {t('zoomClass.NeedFDACSCEU')} </FormLabel>
                                <RadioGroup row aria-label="open" name="open" onChange={handleRemoteChange}>
                                    <FormControlLabel
                                        id="isInPerson"
                                        value="Yes"
                                        checked={ceu.needCEU }
                                        control={<Radio color="primary" />}
                                        label={t('zoomClass.Yes')}
                                        name="isRemote"
                                    />
                                    <FormControlLabel
                                        id="isRemote"
                                        value="No"
                                        checked={ !ceu.needCEU }
                                        control={<Radio color="primary" />}
                                        label={t('zoomClass.No')}
                                        name="isRemote"
                                    />
                                </RadioGroup>
                            </Grid>

                            {ceu.message && 
                                <Alert>
                                    {ceu.message}
                                </Alert>
                            }

                            <Grid item xs={12} sm={6}>
                                <br />
                                <FormLabel component="legend"> {t('zoomClass.NeedCertificationTest')}  </FormLabel>
                                <RadioGroup row aria-label="open" name="open" onChange={handleNeedTest}>
                                    <FormControlLabel
                                        id="isInPerson"
                                        value="Yes"
                                        checked={test.needTest }
                                        control={<Radio color="primary" />}
                                        label={t('zoomClass.Yes')}
                                        name="isRemote"
                                    />
                                    <FormControlLabel
                                        id="isRemote"
                                        value="No"
                                        checked={ !test.needTest }
                                        control={<Radio color="primary" />}
                                        label={t('zoomClass.No')}
                                        name="isRemote"
                                    />
                                </RadioGroup>
                               
                            </Grid>
                            {test.message &&
                                    <Alert>
                                       {test.message}
                                    </Alert>
                                }
                          
                            <br />
                            
                        </Container>

                       

                        {foundCode.searched && <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            {
                            foundCode.code === null ? <h1>{t('EnterCode.CourseCodeNotFound')}</h1> :
                                (foundCode.valid ? <h1> {t('zoomClass.ValidDateText')} {foundCode.code.usedBy} </h1> : 
                                    <h1>{t('EnterCode.CourseHasExpired')}</h1>)
                            }
                        </Grid>}
                        
                        <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button
                                disabled={!foundCode.valid}
                                variant="contained"
                                color="primary"
                                type="submit"
                                onClick={onSubmit}
                            >
                                {t('EnterCode.Continue')}
                            </Button>
                        </Grid>
                        <br />
                    </Grid>
                </>
            

        </>
    )
}

export default withTranslation()(ZoomClass);